module.exports = __webpack_public_path__ + "static/media/PhoenixChildrens.137da18d.png";